import { trackEvent } from "./analytics/analytics";
import { ArController } from "./ar/ar-controller";
import { createIntroScreen } from "./components/intro-screen";
import { createLoadingScreen } from "./components/loading-screen";
import { createStatusOverlay } from "./components/status-overlay";
import { copyExternalBrowserUrl, getExternalBrowserRecommendation } from "./platform/external-browser";
import { shouldAutoStartExperience } from "./platform/launch-options";
import { appState } from "./state/app-state";
import "./styles/base.css";
import "./styles/components.css";
import "./styles/ar.css";

const appRoot = document.createElement("main");
appRoot.className = "app-shell";

const arContainer = document.createElement("div");
arContainer.className = "ar-container";
arContainer.setAttribute("aria-hidden", "true");

const loading = createLoadingScreen();
let externalBrowser = getExternalBrowserRecommendation();
const autoStart = shouldAutoStartExperience();
let startRequested = false;

const controller = new ArController({
  arContainer,
  setLoading(visible, message = "A preparar experiência…") {
    loading.setMessage(message);
    loading.setVisible(visible);
  },
  setCtaVisible(visible) {
    statusOverlay.setCtaVisible(visible);
  },
  onNeedsUserRestart() {
    intro.show();
    intro.setBusy(false);
  },
});

function startExperience(): void {
  externalBrowser = getExternalBrowserRecommendation();

  if (externalBrowser.required) {
    appState.transition("internal-browser");
    trackEvent("webview_blocked", {
      name: "Android QR browser",
      reason: externalBrowser.reason,
    });
    void copyExternalBrowserUrl(externalBrowser.targetUrl).then((copied) => {
      intro.setStartButtonLabel(copied ? "Link copiado" : "Use o menu do navegador");
    });
    return;
  }

  if (startRequested) {
    return;
  }

  startRequested = true;
  intro.setBusy(true);
  intro.hide();
  void controller.start().finally(() => {
    startRequested = false;
    intro.setBusy(false);
  });
}

const intro = createIntroScreen(startExperience);
intro.setStartButtonLabel(externalBrowser.label);
if (externalBrowser.required) {
  appState.transition("internal-browser");
}

const statusOverlay = createStatusOverlay({
  store: appState,
  onRetry() {
    intro.show();
    intro.setBusy(false);
    void controller.retry();
  },
  onCtaClick() {
    void controller.openWhatsApp();
  },
});

appRoot.append(arContainer, intro.element, statusOverlay.element, loading.element);
document.body.append(appRoot);

trackEvent("ar_page_opened");

const preparePromise = externalBrowser.required || autoStart ? undefined : controller.prepare();

if (preparePromise) {
  intro.setBusy(true);
  loading.setMessage("A preparar experiência…");
  loading.setVisible(true);
  preparePromise
    .catch(() => undefined)
    .finally(() => {
      intro.setBusy(false);
      loading.setVisible(false);
    });
}

if (autoStart && !externalBrowser.required) {
  queueMicrotask(startExperience);
}
